module.exports = "/images/bannerFive-mobile.jpg";